import React from 'react';
import styled from 'styled-components';

import Icon from 'js/components/common/Icon';
import { lightGrey2Color, lightGrey3Color } from 'js/config/style';

const Button = styled.button`
  padding: 0;
  width: 2rem;
  text-align: center;
  background: transparent;
  line-height: 1rem;
  height: 2rem;
  border: 1px solid ${lightGrey2Color};
  border-radius: 0.25rem;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  color: ${({ disabled }) => (disabled ? lightGrey3Color.brighten(0.5) : lightGrey3Color)};

  &:hover {
    color: ${({ disabled }) => (disabled ? lightGrey3Color.brighten(0.5) : 'black')};
  }
  &:active {
    box-shadow: 0 1px 3px -1px black inset;
  }
`;

export default props => (
  <Button {...props}>
    <Icon name="search" />
  </Button>
);
